export const pages = {
  // Histories — итог ставки в мобильной таблице
  "components.routes.pages.Histories.table.result.return": "Возврат",
  "components.routes.pages.Histories.table.result.win": "Выигрыш",
  "components.routes.pages.Histories.table.result.loss": "Проигрыш",

  // Positions — заголовок колонки количества
  "components.routes.pages.Positions.table.quantity": "Кол-во",

  // EventDetail — фолбэки названий исходов на мобильных кнопках
  "components.routes.pages.EventDetail.outcome.yes": "Да",
  "components.routes.pages.EventDetail.outcome.no": "Нет",
};
